export class CboModel {
    public idCbo: number;
    public name: string;
    public codCbo: string;
    public datetimeInclusion: Date;
}